import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

export default function DarkModeToggle() {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? "Light mode" : "Dark mode"}
      title={dark ? "Light mode" : "Dark mode"}
      className="theme-toggle"
      data-testid="theme-toggle-btn"
    >
      <span className={`theme-toggle-icon ${dark ? "is-dark" : ""}`}>
        <Sun size={16} className="theme-toggle-sun" />
        <Moon size={16} className="theme-toggle-moon" />
      </span>
    </button>
  );
}
